import { IGiftProps } from 'store/modules/product';

import Modal from 'components/common/Modal';

import * as S from './styles';

interface IModalGetGiftProps {
  setShowModalGetGift(state: boolean): void;
  brinde: IGiftProps;
}

export function ModalGetGift({
  setShowModalGetGift,
  brinde,
}: IModalGetGiftProps) {
  return (
    <S.Container className="modal-get-gift">
      <Modal onClose={() => setShowModalGetGift(false)} withScroll>
        <h4>Parabéns!</h4>

        <div className="modal-get-gift-info">
          <div className="modal-get-gift-details">
            <img
              loading="lazy"
              src={brinde.imagem.mini}
              alt={brinde.descricao}
            />

            <div className="modal-get-gift-name">
              <strong>Você ganhou:</strong>

              <span>{brinde.descricao}</span>
            </div>
          </div>

          <strong className="modal-get-gift-message">
            O item foi adicionado ao carrinho!
          </strong>
        </div>
      </Modal>
    </S.Container>
  );
}
